{
  "breaches": {
    "count": "Tilisi tiedot on vuotanut {count} tietomurrossa.",
    "discovered": "Tämä tietomurto havaittiin ensimmäisen kerran {date}.",
    "empty": {
      "text": "Emme ole löytäneet tietovuotoja tilillesi.",
      "title": "Tietovuotoja ei löytynyt."
    },
    "high": "Korkea",
    "medium": "Keskitaso",
    "title": "Tietoturvaloukkaukset",
    "watchlist": {
      "button": "Lisää sähköposti",
      "text": "Valvonnassa olevat sähköpostiosoitteet",
      "title": "Tarkkailulista"
    }
  },
  "cards": {
    "breaches": {
      "text": "Tältä sivulta voit tarkastaa, onko sähköpostiosoittellasi rekisteröity käyttäjätili ja sen tietoja vuotanut tietomurron seurauksena. Luokittelemme tietomurrot niiden vakavuuden ja vuotaneen tiedon tyypin mukaan. Varmista, että vaihdat salasanasi, jos tietosi ovat paljastuneet tietomurrossa.",
      "title": "Onko tietojasi vuotanut?"
    },
    "overview": {
      "text": "Hei {name}! Kuten tiedät, tietojenkalasteluhyökkäykset kehittyvät jatkuvasti yhä monimutkaisemmiksi ja vaarallisemmiksi. Siksi on ensiarvoisen tärkeää oppia tunnistamaan organisaatiotasi uhkaavat hyökkäykset ja tietää, miten niiltä voi suojautua. Suorita koulutuksia ja kehity tietoturva-asiantuntijaksi askel kerrallaan. Täällä Hubissa voit seurata omaa edistymistäsi.",
      "title": "Tervetuloa Hubiin!"
    },
    "quiz": {
      "text": "Lähde mukaan interaktiiviselle tietovisamatkalle ja testaa taitosi erottaa aidot viestit kalastelusähköposteista. Visailu haastaa sinut tunnistamaan todellisen maailman kyberuhkia ja kehittämään omaa osaamistasi.",
      "title": "Tehdäänpä visailu!"
    },
    "simulations": {
      "text": "Tällä sivulla voit tarkastella Moxsolta viimeisten 90 päivän aikana saamiesi simulaatioiden yksityiskohtia. Ymmärtämällä, miten kalastelusähköpostit on suunniteltu, pystyt tunnistamaan ne ja suojaamaan itsesi niiden vaaroilta.",
      "title": "Oletko joutunut tietojenkalastelun kohteeksi?"
    },
    "videos": {
      "text": "Tämän sivun videoita katsomalla pääset tutustumaan uusimpiin kyberuhkiin ja opit, miten suojaat sekä itsesi että organisaatiosi niiltä. Koulutusvideot ovat katsottavissa silloin, kun sinulle parhaiten sopii.",
      "title": "Valmistaudu oppimaan uutta!"
    }
  },
  "certificate": {
    "certificate_of_completion": "Suorittamistodistus",
    "certificate_unlocked": "Sertifikaatti saavutettu",
    "share_on_linkedin": "Jaa LinkedInissä",
    "show_certificate": "Näytä todistus",
    "text": "Sinulla on todistus suoritetusta kurssista. Miksi et esittelisi sitä?"
  },
  "courses": {
    "all": "Kaikki kurssit",
    "completed": {
      "badge": "Suoritettu",
      "button": "Suorita kurssi",
      "text": "Olet suorittanut kurssin",
      "title": "Hienosti tehty!"
    },
    "content": {
      "breach": {
        "text": "Ota tilisi murtojen havaitseminen käyttöön",
        "title": "Määritä tietomurtojen havaitseminen"
      },
      "download": {
        "button": "Lataa"
      },
      "introduction": {
        "contents": "Sisältö",
        "start": "Aloita kurssi",
        "text": "Kurssin esittely ja yleiskatsaus",
        "title": "Johdanto"
      },
      "quiz": {
        "choose_answer": "Valitse oikea vastaus:",
        "correct": "Oikein",
        "correct_answer": "{label}: {answer}",
        "correct_answer_label": "Oikea vastaus",
        "next_question": "Seuraava kysymys",
        "oh_no": "Harmin paikka!",
        "question_of": "Kysymys {current} / {total}",
        "result": {
          "button": "Suorita testi loppuun",
          "text": "Vastasit oikein {correct} kysymykseen {total} kysymyksestä.",
          "title": "Hienoa!",
          "title_fail": "Melkein perillä!"
        },
        "text": "Testaa taitojasi kokeen avulla",
        "title": "Visa",
        "view_results": "Näytä tulos",
        "well_done": "Hienoa!",
        "your_answer": "{label}: {answer}",
        "your_answer_label": "Vastauksesi"
      },
      "video": {
        "text": "Opi keskeiset käsitteet katsomalla tämä video"
      }
    },
    "continue": "Jatka",
    "featured": "Sinulle suositellut kurssit",
    "lessons": "{count} oppituntia",
    "progress": {
      "button": "Jatka",
      "text": "Olet suorittanut {pct}% tästä kurssista."
    },
    "skip_video": {
      "button": "Ohita",
      "text": "Olet katsonut tämän videon jo aiemmin. Ohitetaanko se?"
    },
    "start_over": "Aloita alusta",
    "title": "Kurssit"
  },
  "dynamic_keys": {
    "api": {
      "errors": {
        "checksum": "Kysymys on vanhentunut",
        "network": "Virhe on tapahtunut",
        "noResponse": "Palvelimelta ei saatu vastausta",
        "streaming": {
          "manifest": "Virhe tapahtui, kun videota toistettiin",
          "platform": "Tätä videota ei tueta laitteellasi.",
          "unavailable": "Tätä videota ei ole saatavilla"
        },
        "unknown": "Tuntematon virhe on tapahtunut"
      },
      "messages": {
        "auth_failed": "Virheellinen sähköpostiosoite",
        "csrf": "Päivitä sivu ja yritä uudelleen",
        "email_missing": "Tilille ei ole liitetty sähköpostiosoitetta",
        "file_not_found": "Tiedostoa ei löydy",
        "general_exception": "Virhe on tapahtunut",
        "invalid_answer": "Virheellinen vastaus",
        "invalid_course": "Virheellinen kurssi",
        "invalid_domain": "Virheellinen toimialue",
        "invalid_email": "Virheellinen sähköpostiosoite",
        "invalid_grant": "Yhteydenotto palveluntarjoajaan epäonnistui",
        "invalid_locale": "Käännöstä ei löytynyt",
        "invalid_option": "Virheellinen valinta",
        "invalid_permissions": "Sinulla ei ole oikeutta käyttää tätä ominaisuutta.",
        "invalid_point": "Virheellinen piste",
        "invalid_provider": "Virheellinen tarjoaja",
        "invalid_quiz": "Virheellinen tietovisa",
        "invalid_token": "Istuntosi on vanhentunut",
        "invalid_video": "Virheellinen video",
        "missing_code": "Yritä uudelleen",
        "two_factor_code_expired": "Kaksivaiheinen koodi on vanhentunut",
        "two_factor_code_invalid": "Kaksivaiheinen koodi on virheellinen",
        "unauthorized": "Sinulla ei ole oikeutta käyttää tätä ominaisuutta.",
        "user_not_found": "Käyttäjää ei ole olemassa"
      },
      "validations": {
        "messages": {
          "throttle": "Liian monta kirjautumisyritystä. Yritä myöhemmin uudelleen."
        }
      }
    },
    "breaches": {
      "data_classes": {
        "account_balances": "Tilien saldot",
        "address_book_contacts": "Osoitekirjan yhteystiedot",
        "age_groups": "Ikäryhmät",
        "ages": "Iät",
        "appointments": "Ajanvaraukset",
        "apps_installed_on_devices": "Sovellukset asennettuina laitteisiin",
        "astrological_signs": "Horoskooppimerkit",
        "audio_recordings": "Äänitallenteet",
        "auth_tokens": "Todennustunnukset",
        "avatars": "Avatarit",
        "bank_account_numbers": "Pankkitilinumeroita",
        "beauty_ratings": "Kauneusarviot",
        "biometric_data": "Biometriset tiedot",
        "bios": "Biotiedot",
        "browser_user_agent_details": "Selainkäyttäjäagentin yksityiskohdat",
        "browsing_histories": "Selaushistoria",
        "buying_preferences": "Ostomieltymykset",
        "car_ownership_statuses": "Auton omistustiedot",
        "career_levels": "Uran tasot",
        "cellular_network_names": "Matkaviestiverkon nimet",
        "charitable_donations": "Hyväntekeväisyyslahjoitukset",
        "chat_logs": "Keskustelulokit",
        "credit_card_cvv": "Luottokortin CVV",
        "credit_cards": "Luottokortit",
        "credit_status_information": "Luottotiedot",
        "customer_feedback": "Asiakaspalaute",
        "customer_interactions": "Asiakaskohtaamiset",
        "dates_of_birth": "Syntymäajat",
        "deceased_date": "Kuolinpäivämäärät",
        "deceased_statuses": "Vainajien tilat",
        "device_information": "Laitetiedot",
        "device_serial_numbers": "Laitteiden sarjanumerot",
        "device_usage_tracking_data": "Laitteen käytön seurantatiedot",
        "drinking_habits": "Juomatottumukset",
        "driver_s_licenses": "Ajokortit",
        "drug_habits": "Huumausaineiden käyttötiedot",
        "eating_habits": "Ruokailutottumukset",
        "education_levels": "Koulutustasot",
        "email_addresses": "Sähköpostiosoitteet",
        "email_messages": "Sähköpostiviestit",
        "employers": "Työnantajat",
        "employment_statuses": "Työsuhteen tilat",
        "encrypted_keys": "Salatut avaimet",
        "ethnicities": "Etnisyydet",
        "family_members_names": "Perheenjäsenten nimet",
        "family_plans": "Perhesuunnitelmat",
        "family_structure": "Perherakenne",
        "financial_investments": "Finanssisijoitukset",
        "financial_transactions": "Rahoitustapahtumat",
        "fitness_levels": "Kuntotasot",
        "genders": "Sukupuolet",
        "geographic_locations": "Maantieteelliset sijainnit",
        "government_issued_i_ds": "Hallituksen myöntämät henkilötunnukset",
        "health_insurance_information": "Sairausvakuutustiedot",
        "historical_passwords": "Aiemmat salasanat",
        "hiv_statuses": "HIV-statukset",
        "home_loan_information": "Asuntolainatiedot",
        "home_ownership_statuses": "Asunnonomistajuustiedot",
        "homepage_ur_ls": "Kotisivujen URL-osoitteet",
        "imei_numbers": "IMEI-numerot",
        "imsi_numbers": "IMSI-numerot",
        "income_levels": "Tulotasot",
        "instant_messenger_identities": "Pikaviestisovellusten henkilöllisyydet",
        "ip_addresses": "IP-osoitteet",
        "job_applications": "Työhakemukset",
        "job_titles": "Ammattinimikkeet",
        "licence_plates": "Rekisterikilvet",
        "living_costs": "Elinkustannukset",
        "login_histories": "Kirjautumishistoriat",
        "mac_addresses": "MAC-osoitteet",
        "marital_statuses": "Siviilisäädöt",
        "mnemonic_phrases": "Muistikoodeja",
        "mothers_maiden_names": "Äitien tyttönimet",
        "names": "Nimet",
        "nationalities": "Kansallisuudet",
        "net_worths": "Nettovarallisuudet",
        "nicknames": "Nimimerkit",
        "occupations": "Ammatit",
        "parenting_plans": "Perhesuunnittelmat",
        "partial_credit_card_data": "Osittaiset luottokorttitiedot",
        "partial_dates_of_birth": "Osittaiset syntymäajat",
        "passport_numbers": "Passinumerot",
        "password_hints": "Salasanavihjeet",
        "password_strengths": "Salasanojen vahvuudet",
        "passwords": "Salasanat",
        "payment_histories": "Maksuhistoriat",
        "payment_methods": "Maksutavat",
        "personal_descriptions": "Henkilökohtaiset kuvaukset",
        "personal_health_data": "Henkilökohtaiset terveystiedot",
        "personal_interests": "Henkilökohtaiset kiinnostuksen kohteet",
        "phone_numbers": "Puhelinnumerot",
        "photos": "Valokuvat",
        "physical_addresses": "Fyysiset osoitteet",
        "physical_attributes": "Fyysiset ominaisuudet",
        "pi_ns": "PIN-koodit",
        "places_of_birth": "Syntymäpaikat",
        "political_donations": "Poliittiset lahjoitukset",
        "political_views": "Poliittiset näkemykset",
        "private_messages": "Yksityisviestit",
        "professional_skills": "Ammattitaidot",
        "profile_photos": "Profiilikuvat",
        "purchases": "Ostot",
        "purchasing_habits": "Ostotottumukset",
        "races": "Rodut",
        "recovery_email_addresses": "Varaosoitteet sähköpostille",
        "relationship_statuses": "Parisuhdetilat",
        "religions": "Uskonnot",
        "reward_program_balances": "Palkkio-ohjelman saldot",
        "salutations": "Tervehdykset",
        "school_grades_class_levels": "Koulutodistukset (luokkatasot)",
        "security_questions_and_answers": "Turvakysymykset ja -vastaukset",
        "sexual_fetishes": "Seksuaaliset fetissit",
        "sexual_orientations": "Seksuaaliset suuntautumiset",
        "smoking_habits": "Tupakointitottumukset",
        "sms_messages": "Tekstiviestit",
        "social_connections": "Sosiaaliset yhteydet",
        "social_media_profiles": "Sosiaalisen median profiilit",
        "social_security_numbers": "Sosiaaliturvatunnukset",
        "spoken_languages": "Puhutut kielet",
        "spouses_names": "Puolisoiden nimet",
        "support_tickets": "Tukipyynnöt",
        "survey_results": "Kyselyn tulokset",
        "taxation_records": "Verotustiedot",
        "telecommunications_carrier": "Teleoperaattorit",
        "time_zones": "Aikavyöhykkeet",
        "travel_habits": "Matkustustottumukset",
        "user_statuses": "Käyttäjätilanteet",
        "user_website_ur_ls": "Käyttäjän verkkosivuston URL-osoitteet",
        "usernames": "Käyttäjänimet",
        "utility_bills": "Sähkölaskut",
        "vehicle_details": "Ajoneuvon tiedot",
        "website_activity": "Verkkosivuston toiminta",
        "work_habits": "Työtavat",
        "years_of_professional_experience": "Ammatillisen kokemuksen vuodet"
      }
    },
    "certificates": {
      "compliance": "Tietoturvakoulutus"
    },
    "courses": {
      "toc": {
        "breach-content": "Päivämäärän rikkomukset",
        "file-content": "Lataa",
        "intro-content": "Johdanto",
        "quiz-content": "Tietovisa",
        "text-content": "Tapaus",
        "video-content": "Video"
      }
    },
    "locales": {
      "current": "suomi",
      "da_DK": "tanska",
      "de_DE": "saksa",
      "en_US": "englanti",
      "es_ES": "Espanja",
      "fi_FI": "suomi",
      "fr_FR": "Ranska",
      "nb_NO": "norja",
      "nl_NL": "hollanti",
      "pl_PL": "puola",
      "pt_PT": "portugali",
      "sv_SE": "ruotsi"
    },
    "onboarding": {
      "course": {
        "content": [
          {
            "attributes": {
              "description": "Tervehdys ja tervetuloa henkilökohtaiselle oppimisalustallesi! Olemme iloisia saadessamme sinut mukaan ja innokkaita auttamaan sinua oppimistavoitteidesi saavuttamisessa.",
              "title": "Tervetuloa Moxsoon"
            },
            "layout": "intro-content"
          },
          {
            "attributes": {
              "title": "Kuinka Moxso toimii",
              "video_id": "af422bc9-145b-4cf4-a9d4-de16a9dcbc61"
            },
            "layout": "video-content"
          },
          {
            "layout": "breach-content"
          }
        ],
        "id": "4a36d036-d378-449a-aa85-e62afd6e31f4",
        "image": "https://edge-cdn.moxso.com/course/4SuGbThgaOWPd69hzrD8oYqkwEkTvNzDMPEoHhrK.jpg",
        "title": "Aloitetaan 🙌",
        "video": "https://edge-cdn.moxso.com/course/Tzk7FcRcvAHMlm35ACZNK4zIsRFvQGQimfpcKeCW.mp4"
      },
      "quiz_questions": {
        "data_privacy": {
          "category": "Tietosuojatietoisuus",
          "options": {
            "high": "Tuttu",
            "low": "Ei tuttu",
            "medium": "Jonkin verran tuttu"
          },
          "question": "Kuinka perehtynyt olet tietosuojan perusperiaatteisiin (esim. GDPR)?"
        },
        "device_security": {
          "category": "Laiteturvallisuuskäytännöt",
          "options": {
            "high": "Kyllä, aina",
            "low": "Ei, ei koskaan",
            "medium": "Joskus"
          },
          "question": "Päivitätkö säännöllisesti laitteesi ja käytätkö tietoturvatyökaluja, kuten VPN:ää?"
        },
        "digital_threats": {
          "category": "Digitaalisten uhkien tietoisuus",
          "options": {
            "high": "Tuttu",
            "low": "Ei tuttu",
            "medium": "Jonkin verran tuttu"
          },
          "question": "Kuinka hyvin tunnet digitaaliset uhat, kuten haittaohjelmat, tietojenkalastelun ja kiristysohjelmat?"
        },
        "hybrid_work": {
          "category": "Etätyön turvallisuus",
          "options": {
            "high": "Erittäin varma",
            "low": "Epävarma",
            "medium": "Jonkin verran varma"
          },
          "question": "Kuinka varma olet siitä, että pystyt ylläpitämään tietoturvan työskennellessäsi etänä (esim. julkisessa Wi-Fi-verkossa)?"
        },
        "incidents_breaches": {
          "category": "Tapahtumailmoitus",
          "options": {
            "high": "Kyllä",
            "low": "Ei",
            "medium": "Minulla on yleinen käsitys"
          },
          "question": "Tiedätkö oikean menettelytavan tietoturvapoikkeaman tai -rikkomuksen raportointiin?"
        },
        "passwords_accounts": {
          "category": "Salasanojen hallinta",
          "options": {
            "high": "Käytän salasananhallintatyökalua",
            "low": "Käytän uudelleen salasanoja",
            "medium": "Luoan ainutlaatuisia ja vahvoja salasanoja"
          },
          "question": "Kuinka hallitset työtiliisi liittyviä salasanoja?"
        },
        "phishing": {
          "category": "Tietojenkalastelun tunnistaminen",
          "options": {
            "high": "Erittäin varma",
            "low": "Epävarma",
            "medium": "Jossain määrin varma"
          },
          "question": "Kuinka varma olet siitä, että tunnistat kalasteluyritykset sähköposteissa ja muiden viestikanavien viesteissä?"
        },
        "physical_security": {
          "category": "Fyysiset turvallisuuskäytännöt",
          "options": {
            "high": "Aina",
            "low": "Harvoin",
            "medium": "Usein"
          },
          "question": "Kuinka usein turvaat työtilasi (esim. lukitsemalla tietokoneesi ja varmistamalla arkaluontoisten asiakirjojen asianmukaisen säilyttämisen)?"
        },
        "secure_browsing": {
          "category": "Turvalliset selaustottumukset",
          "options": {
            "high": "Kyllä, aina",
            "low": "Ei, en koskaan",
            "medium": "Usein"
          },
          "question": "Yritätkö välttää julkisten Wi-Fien käyttöä ja epäilyttävien linkkien klikkaamista internetissä?"
        }
      },
      "steps": {
        "finished": "Valmis",
        "introduction": "Esittely",
        "quiz": "Tietovisa"
      }
    },
    "partners": {
      "cancer": "Tanskan syöpäyhdistys",
      "itf": "IT Forum"
    },
    "quiz": {
      "error": {
        "checksum": "Virheellinen tarkistussumma",
        "option": "Vastausta ei tunnistettu"
      },
      "intro": {
        "button": "Aloita tietovisa",
        "text": "Käymme läpi 5 sähköpostia Moxso-postilaatikossasi. Osa sähköposteista saattaa olla huijareilta, jotka yrittävät saada pääsyn arkaluontoisiin tietoihin - sinun täytyy tunnistaa, onko sähköposti tietojenkalastelua vai ei. Oletko valmis?",
        "title": "Valmis raportoimaan?"
      },
      "multiple-choice": {
        "heading": "Etsi virhe tästä sähköpostista",
        "text": "valintakysymysten ohjeteksti"
      },
      "options": {
        "email": "Sähköposti",
        "false": "Tämä ei ole tietojenkalastelua",
        "help": {
          "email": "Lähettäjään ei voi luottaa",
          "false": "Sähköpostia ei tulisi raportoida",
          "link": ".Linkki ei johda luotettavaan kohteeseen.",
          "not-phishing": "Tämä EI ole tietojenkalastelua",
          "true": "Sähköposti tulisi ilmoittaa"
        },
        "link": "Linkki",
        "not-phishing": "Tämä ei ole tietojen kalastelua",
        "true": "Tämä ON tietojenkalastelua"
      },
      "title": "Visailu",
      "true-false": {
        "heading": "Onko tämä tietojenkalasteluviesti?",
        "text": "Määritä, onko tämä huijaussähköposti vai ei."
      }
    },
    "training": {
      "training_restritions": {
        "course": {
          "description": "Tätä kurssia ei voi avata. Valinnaiset kurssit on lukittu, mutta pakollinen koulutus on aina saatavilla.",
          "title": "Tämä kurssi on lukittu"
        },
        "quiz": {
          "description": "Olet saavuttanut harjoittelurajasi. Valinnaiset tietovisat on lukittu toistaiseksi.",
          "title": "Tietovisaraja saavutettu"
        },
        "video": {
          "description": "Olet saavuttanut harjoittelurajasi. Valinnaiset videot on lukittu, mutta pakollinen koulutus on aina saatavilla.",
          "title": "Videoraja saavutettu"
        }
      }
    },
    "training_restrictions": {
      "course": {
        "description": "Tätä kurssia ei voi avata. Valinnaiset kurssit on lukittu, mutta pakollinen koulutus on aina saatavilla.",
        "title": "Tämä kurssi on lukittu"
      },
      "quiz": {
        "description": "Olet saavuttanut harjoittelurajasi. Valinnaiset tietovisat on lukittu toistaiseksi.",
        "title": "Tietovisaraja saavutettu"
      },
      "reset": "Nollautuu maanantaina",
      "video": {
        "description": "Olet saavuttanut harjoittelurajasi. Valinnaiset videot on lukittu, mutta pakollinen koulutus on aina saatavilla.",
        "limit_reached": "Raja saavutettu",
        "title": "Videoraja saavutettu"
      }
    },
    "videos": {
      "category": {
        "advanced": {
          "text": "Tämä opetussarja on suunnattu erityisesti niille, jotka ovat kiinnostuneita kyberturvallisuudesta ja haluavat ymmärtää hakkerointiin sekä tietoturvaan liittyviä toimintamekanismeja syvällisemmin. Jos tavoitteenasi on hallita vain aiheen perusasiat, sarjan katsominen ei ole välttämätöntä. Mikäli kuitenkin haluat syventää osaamistasi hakkeroinnista, kyberhyökkäyksistä ja oman tietoturvasi vahvistamisesta, olet oikeassa paikassa.",
          "title": "Edistynyt",
          "tooltip": "Tule hakkeroinnin asiantuntijaksi nopeasti"
        },
        "ai": {
          "text": "Tämä opetussarja käsittelee tekoälyn roolia kyberturvallisuudessa. Tekoälyllä on kaksinainen vaikutus: se on arvokas työkalu IT-turvallisuuden ammattilaisille uhkien tunnistamisessa ja torjumisessa, mutta se on myös tehokas väline hakkerien käsissä. Sarja auttaa sinua ymmärtämään tekoälyn vaikutuksia kalasteluhyökkäyksiin opettaen samalla hyödyntämään sitä turvallisesti. Vaikka tekoäly on voimakas työkalu sekä puolustajille että hyökkääjille, sinun oma käyttäytymisesi on edelleen keskeisin tekijä turvallisuudessasi.",
          "title": "Tekoäly ja kyberturvallisuus",
          "tooltip": "Tutki tekoälyn monimutkaista roolia kyberturvallisuudessa"
        },
        "compliance": {
          "text": "Tämä opetussarja käsittelee keskeistä kyberturvallisuuteen liittyvää lainsäädäntöä, standardeja ja sertifiointeja, jotka auttavat suojaamaan organisaatiota digitaalisilta uhilta. Videot esittelevät muun muassa NIS2-direktiivin ja DORA-sääntelyn sekä niiden merkityksen vaatimustenmukaisuudelle, riskienhallinnalle ja käytännön tietoturvatoimille.",
          "title": "Sertifikaatit ja vaatimustenmukaisuus",
          "tooltip": "Ymmärrä sertifikaattien ja sääntöjen noudattamisen merkitys"
        },
        "gdpr": {
          "text": "Tämä opetussarja käsittelee GDPR-asetuksen keskeisiä sääntöjä, vaatimuksia ja periaatteita. Vuonna 2018 voimaan tullut GDPR velvoittaa kaikkia organisaatioita käsittelemään ja suojaamaan henkilötietoja huolellisesti ja lainmukaisesti. Sarjassa käydään läpi GDPR:n keskeisimmät ja ajankohtaisimmat osa-alueet, jotka auttavat ymmärtämään, miten henkilötietoja tulee käsitellä oikein arjen työssä. Videoiden sisältö on toimialariippumatonta ja soveltuu kaikille organisaatioille.",
          "title": "GDPR",
          "tooltip": "Opi tärkeimmät GDPR-vaatimukset ja -säännöt sekä kuinka voit noudattaa niitä jokapäiväisessä elämässäsi."
        },
        "hacking": {
          "text": "Tämä opetussarja tutustuttaa sinut kyberhyökkäysten taustalla toimiviin henkilöihin – hakkereihin. Sarjassa tarkastellaan heidän käyttämiään menetelmiä anonymiteetin säilyttämiseen verkossa sekä keinoja, joilla he voivat hankkia tuloja. Videot avaavat eri hakkerityyppejä ja selittävät, miksi heidän jäljittämisensä ja kiinni saamisensa voi olla haastavaa.",
          "title": "Hakkerin elämä",
          "tooltip": "Tutustu kyberhyökkäysten takana oleviin ihmisiin, maailman hakkereihin"
        },
        "money_laundering": {
          "text": "Tämä opetussarja tutustuttaa sinut erilaisiin menetelmiin, joita rikolliset käyttävät rahanpesuun. Samalla opit, miten rahanpesua voidaan tunnistaa, ehkäistä ja torjua.",
          "title": "Rahanpesu",
          "tooltip": "Opi erilaisia menetelmiä, joita rikolliset käyttävät rahanpesuun, ja kuinka rahanpesu voidaan havaita ja estää"
        },
        "phishing": {
          "text": "Tämä opetussarja käsittelee yhtä yleisimmistä maailmanlaajuisia kyberuhista eli tietojenkalastelua. Tietojenkalasteluhyökkäykset voivat toimia itsenäisinä hyökkäyksinä tai olla ensimmäinen askel laajemmassa ja kehittyneemmässä hyökkäyksessä. Tietojenkalasteluhyökkäyksissä keskeistä on se, että sinun oma valintasi klikata tai jättää klikkaamatta epäilyttävää linkkiä voi ratkaista sen, onnistuuko hyökkäys. Siksi tietojenkalastelun tunnistaminen on keskeinen osa kyberturvallisuutta. Tämän sarjan videot auttavat sinua ymmärtämään, miten tietojenkalasteluhyökkäykset toimivat, miten hyökkääjät niitä toteuttavat ja ennen kaikkea, miten voit välttää joutumasta niiden uhriksi.",
          "title": "Tietojenkalastelu",
          "tooltip": "Tutustu maailman yleisimmän kyberhyökkäyksen piirteisiin"
        },
        "physical_security": {
          "text": "Tämä opetussarja korostaa hyvän tietoturvan merkitystä sekä työpaikalla että kotona. Kyberturvallisuus ei koske vain laitteiden suojaamista, vaan myös niiden käyttöympäristöä ja siihen liittyviä käytäntöjä. Etätyössä on entistä tärkeämpää toimia turvallisesti myös kodin ulkopuolella. Sarja antaa valmiuksia turvalliseen työskentelyyn ja kattaa aiheita vierailijahallinnasta mobiililaitteiden tietoturvaan sekä julkisten verkkojen käytön riskeihin.",
          "title": "Fyysinen turvallisuus",
          "tooltip": "Opi, miksi fyysinen turvallisuus on olennainen osa hyvää kyberturvallisuutta"
        },
        "tips_and_tricks": {
          "text": "Tämä opetussarja auttaa sinua vahvistamaan kyberturvallisuuttasi. Saat konkreettisia ja helposti sovellettavia keinoja parantaa turvallisuutta verkossa niin henkilökohtaisessa elämässäsi kuin työpaikallasi. Videot avaavat myös, miksi aiemmin saadut kyberturvallisuusohjeet ovat tärkeitä ja miten niiden jatkuva noudattaminen auttaa vähentämään riskejä arjessa.",
          "title": "Vinkkejä ja niksejä",
          "tooltip": "Opi parantamaan omaa kyberturvallisuuttasi"
        },
        "types_of_hacking": {
          "text": "Tämä opetussarja tarjoaa näkemyksiä erilaisiin menetelmiin, joita hakkerit voivat käyttää yrittäessään huijata sinua. Jokaisessa jaksossa perehdytään yhteen hakkerointitekniikkaan: sen toimintaperiaatteisiin, hyökkääjien tavoitteisiin sekä mahdollisiin seurauksiin, jos joutuu hyökkäyksen kohteeksi. Sarjan videot auttavat sinua tunnistamaan uhkia paremmin ja valmistautumaan tehokkaammin tuleviin kyberhyökkäyksiin.",
          "title": "Hakkeroinnin tyypit",
          "tooltip": "Saa tietoa hakkereiden käyttämistä eri menetelmistä"
        },
        "uploads": {
          "text": "Täältä löydät organisaatiosi lataamia videoita, jotka on räätälöity vastaamaan organisaatiosi erityispiirteitä.",
          "title": "Lataukset",
          "tooltip": "Katso organisaatiosi lataamia videoita erityistarpeitasi varten"
        }
      }
    }
  },
  "error_page": {
    "error_has_been_reported": "Virhe on raportoitu tiimillemme tunnuksella: {errorId}. Jos tarvitset välitöntä apua, ota rohkeasti yhteyttä tukitiimiimme osoitteessa support{'@'}moxso.com.",
    "go_back": "Siirry takaisin etusivulle",
    "text": "Tuntematon virhe tapahtui, emmekä voineet suorittaa pyyntöäsi. Olemme tästä pahoillamme. Yritä myöhemmin uudelleen.",
    "title": "Jotain meni pieleen"
  },
  "forms": {
    "fields": {
      "code": "Kertakäyttöinen salasana",
      "email": "Sähköposti"
    },
    "placeholders": {
      "email": "nimi{'@'}company.com"
    }
  },
  "loading": "Ladataan",
  "locale": {
    "current": "Suomi",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "finnish": "Suomi",
    "french": "Français",
    "german": "Deutsch",
    "norwegian": "Norsk",
    "polish": "Polski",
    "portugese": "Português",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "login": {
    "buttons": {
      "login": "Kirjaudu sisään",
      "next": "Seuraava",
      "send_one_time_code": "Lähetä kertakäyttökoodi",
      "try_again": "Lähetä koodi uudelleen"
    },
    "choose_provider": "Valitse palveluntarjoaja",
    "loading": "Ladataan",
    "sso": {
      "validating": "Vahvistetaan SSO:ta"
    },
    "title": "Kirjaudu sisään",
    "two_factor": {
      "text": "Olemme lähettäneet kertakäyttöisen salasanan sähköpostiisi.",
      "title": "Tarkista sähköpostisi"
    }
  },
  "mandatory": {
    "completed": {
      "text": "Olet suorittanut esiteltävän sisällön, jonka ylläpitäjäsi on valinnut sinulle.",
      "title": "Hienoa!"
    },
    "deadline": "Määräaika: {date}",
    "next_training": "Seuraava määrätty koulutus",
    "policy_fallback_title": "Käytäntö",
    "quiz_questions": "{count} kysymys | {count} kysymystä",
    "retake": "Uudelleen määrätty",
    "start_quiz": "Aloita visailu",
    "text": "Sinulle määrätty koulutus",
    "title": "Määrätty koulutus",
    "view_policy": "Näytä politiikka"
  },
  "navigation": {
    "breaches": "Tietoturvaloukkaukset",
    "courses": "Kurssit",
    "exit": "Poistu",
    "exit_onboarding": "Ohita perehdytys",
    "login": "Kirjaudu sisään",
    "logout": "Kirjaudu ulos",
    "onboarding": "Johdanto",
    "onboarding_finished": "Perehdytys suoritettu loppuun",
    "onboarding_intro": "Aloitusopas esittelyssä",
    "onboarding_quiz": "Aloituskysely",
    "overview": "Etusivu",
    "simulation_click": "Kalastelusimulaatio",
    "simulations": "Simulaatiot",
    "videos": "Videot"
  },
  "onboarding": {
    "finished": {
      "button": "Aloita oppiminen",
      "subtitle": "Olet suorittanut perehdytyksesi! Hienoa työtä, olet valmis aloittamaan Moxson käytön. Olemme innoissamme, että olet mukana, ja odotamme innolla auttamista tavoitteidesi saavuttamisessa!",
      "title": "Siinä se!"
    },
    "intro": {
      "form": {
        "button": "Tallenna ja jatka",
        "help": "Valitse kieli, jota haluat käyttää oppimiskokemuksessasi.",
        "label": "Valitse kielesi",
        "placeholder": "Valitse kieli"
      },
      "header": {
        "description": "Tervetuloa oppimisalustallesi! Olemme innoissamme, että olet täällä ja valmiina auttamaan sinua saavuttamaan tavoitteesi. Aloitetaan profiilisi luomisella ja mukautetaan kokemuksesi.",
        "title": "Tervetuloa Moxsoon"
      }
    },
    "quiz": {
      "header": {
        "description": "Täytä tämä lyhyt kysely, jotta voimme ymmärtää tämänhetkisen tasosi ja räätälöidä koulutuksen vastaamaan tarpeitasi.",
        "title": "Kuinka hyvin tunnet kyberturvallisuuden?"
      }
    }
  },
  "overview": {
    "start_quiz": "Aloita visailu",
    "welcome": "Tervetuloa takaisin"
  },
  "partner_text": "Moxso-alusta esitetään yhteistyössä {partner} kanssa.",
  "policies": {
    "cancel": {
      "text": "Tämä käytäntö on peruutettu järjestelmänvalvojasi toimesta.",
      "title": "Peruutettu käytäntö"
    },
    "continue": "Jatka",
    "expired": {
      "text": "Tämä käytäntö on vanhentunut eikä ole enää saatavilla.",
      "title": "Vanhentunut käytäntö"
    },
    "focus": "Keskittyminen",
    "history": {
      "count": "{count} allekirjoitettua",
      "show_less": "Näytä vähemmän",
      "signed": "Allekirjoitettu: {date}",
      "subtitle": "Tarkastele politiikkoja, jotka olet jo allekirjoittanut.",
      "title": "Allekirjoitetut politiikat",
      "view_more": "Näytä lisää"
    },
    "next": "Seuraava",
    "overview": "Sisällön yleiskatsaus",
    "policy": "Politiikka",
    "quiz": {
      "confirmation_card_locked": "Sinun on suoritettava tietovisa jatkaaksesi",
      "subtitle": "Osoita ymmärtäväsi käytännön tekemällä tämä koe.",
      "subtitle_completed": "Olet suorittanut tietovisan, vahvista käytännön lukeminen saadaksesi valmiiksi.",
      "title": "Visa",
      "title_completed": "Tietovisa suoritettu"
    },
    "reader": "Lukija",
    "signature": {
      "button": "Vahvista",
      "checkbox_label": "Olen lukenut menettelyn",
      "company": "Yritys",
      "completed": {
        "button": "Poistu",
        "policy_completed": "Politiikka hyväksytty",
        "subtitle": "Hienoa työtä! Olet hyväksynyt käytännön.",
        "title": "Politiikka hyväksytty"
      },
      "ip_adress": "IP-osoite",
      "subtitle": "Vahvistamalla hyväksyt, että olet lukenut ja ymmärtänyt käytännön.",
      "title": "Vahvista käytännön lukeminen",
      "user_agent": "Käyttäjäagentti"
    },
    "this_policy_doesnt_exist_in_this_language": "Tämä politiikka ei ole saatavissa suomeksi. Näytetään englanninkielinen versio."
  },
  "quiz": {
    "analyze": {
      "text": "Analysoi tämä sähköposti ja hanki apua",
      "title": "Epäilyttääkö?"
    },
    "feedback": {
      "no": "Ei",
      "text": "Oliko tämä sivu hyödyllinen?",
      "thanks": "Kiitos palautteestasi!",
      "yes": "Kyllä"
    },
    "help": {
      "button": "Seuraava kysymys",
      "text": "Olemme analysoineet sähköpostin ja saaneet seuraavan tuloksen.",
      "title": "Sähköpostianalyysi"
    },
    "intro": {
      "button": "Aloita visailu",
      "text": "Käymme läpi 5 sähköpostia Moxso-postilaatikossasi. Osa sähköposteista saattaa olla huijareilta, jotka yrittävät päästä käsiksi arkaluontoisiin tietoihin - sinun on tunnistettava, onko sähköposti kalastelua vai ei. Oletko valmis?",
      "title": "Valmis raportoimaan?"
    },
    "preview": "Sähköpostin esikatselu",
    "question": "Kysymys {current} / {total}",
    "result": {
      "go_back": "Siirry etusivulle",
      "mails": "Posti havaittu | Postit havaittu",
      "points": "Ansaitut pisteet",
      "text": {
        "bad": "Valitettavasti luokittelit vain {count} sähköpostin oikein. Mutta muista: Harjoitus tekee mestarin! | Valitettavasti luokittelit vain {count} sähköpostia oikein. Mutta muista: Harjoitus tekee mestarin!",
        "good": "Lajittelit sähköposteista {count} oikein ja suoritit tietovisan. Jatka samaan malliin!"
      },
      "title": {
        "bad": "Parempi onni seuraavalla kerralla",
        "good": "Hyvin tehty!"
      }
    },
    "title": "Tietovisa"
  },
  "resilience_score": {
    "long_text": "Resilienssipistemäärä mittaa kykyäsi kestää kyberhyökkäyksiä. Pistemääräsi perustuu suoriutumiseesi tietovisoissa, videoissa ja simulaatioissa sekä siihen, miten aktiivisesti kouluttaudut. Mitä korkeampi resilienssipistemääräsi on, sitä todennäköisemmin pystyt suojata itseäsi ja työpaikkaasi kyberhyökkäyksiltä.",
    "quizzing": {
      "text": "Aktiivisuuttasi seurataan. Kouluta itseäsi monivalintakokeissa vahvistaaksesi resilienssiäsi.",
      "title": "Visailut"
    },
    "show_breakdown": "Näytä erittely",
    "simulations": {
      "text": "Tietojenkalasteluviestien tunnistaminen on keskeinen osa resilienssiä. Älä klikkaa ja muista raportoida!",
      "title": "Simulaatiot"
    },
    "skills": {
      "text": "Taitosi mitataan sillä, miten hyvin menestyt tietovisoissa. Oikeat vastaukset nostavat resilienssipisteitäsi.",
      "title": "Taidot"
    },
    "text": "Nämä pisteet mittaavat kykyäsi kestää kyberhyökkäyksiä.",
    "title": "Resilienssipisteesi",
    "videos": {
      "text": "Videot ovat koulutuksesi keskiössä. Vahvista resilienssiäsi ja syvennä tietoturvaosaamistasi katsomalla koulutusvideoita.",
      "title": "Videot"
    }
  },
  "search": {
    "empty": "Aloita jotain etsimällä...",
    "no_results": "Ei tuloksia löytynyt",
    "placeholder": "Hae...",
    "popular": "Suositut haut",
    "popular_terms": ["Kiristysohjelma", "Sosiaalinen manipulointi"]
  },
  "simulation": {
    "alert": {
      "text": "Tämä sähköposti on osa automatisoitua tietojenkalasteluharjoitusta, joten älä huoli, se on vain testi.",
      "title": "Tämä on tietojenkalastelusimulaatio"
    },
    "baseline": {
      "text": "Tällä hetkellä testaamme kollegoitasi. Pyydämme kohteliaasti, ettet jaa tätä viestiä.",
      "title": "Voitko pitää salaisuuden?"
    },
    "branding": {
      "text": "Olemme täällä auttamassa, joten älä epäröi ottaa yhteyttä.",
      "title": "Tämän harjoituksen toimitti Moxso"
    },
    "delivered_by": {
      "text": "Tämän harjoituksen toimitti Moxso organisaatiosi nimissä. Jos sinulla on kysyttävää, ota rohkeasti yhteyttä osoitteeseen {contactEmail}.",
      "title": "Tietoja tästä harjoituksesta"
    },
    "preview": "Sähköpostin esikatselu",
    "resilience_score": {
      "text": "Resilienssipisteesi mittaa kykyäsi kestää kyberhyökkäyksiä.",
      "title": "Resilienssipisteesi"
    },
    "submission": {
      "text": "Napsautit linkkiä ja päädyit väärennetylle mutta vakuuttavalle verkkosivulle. Todellisessa tietojenkalasteluhyökkäyksessä kirjautumistietosi olisivat voineet joutua vääriin käsiin. Onneksi tämä oli vain testi.",
      "title": "Mitä juuri tapahtui?"
    },
    "training": {
      "button": "Aloita koulutuksesi"
    }
  },
  "simulations": {
    "count": "Olet saanut {count} simulaatiota Moxsolta viimeisen 90 päivän aikana.",
    "empty": {
      "text": "Et ole saanut simulaatioita viimeisten 90 päivän aikana.",
      "title": "Ei simulaatioita löytynyt"
    },
    "joined": "Liittyi Moxson koulutusohjelmaan",
    "title": "Simulaatiot",
    "tooltip": {
      "click": "Olet napsauttanut linkkiä tässä simulaatiossa",
      "report": "Olet ilmoittanut tästä simulaatiosta",
      "submit": "Olet kirjautunut sisään tähän simulaatioon."
    }
  },
  "sso": {
    "login_with": "Jatka palvelulla {provider}",
    "or": "tai käytä",
    "redirect": "Uudelleenohjataan"
  },
  "statistics": {
    "leaderboard": "Tulostaulukko",
    "missing_data": {
      "text": "Sinun on ansaittava pisteitä nähdäksesi sijoituksesi pistetaulukossa",
      "title": "Ansaitse pisteitä nähdäksesi sijoituksesi"
    },
    "points_earned": "{count} pistettä ansaittu",
    "resilience_score": "Resilienssipisteesi"
  },
  "videos": {
    "error": "Suoratoisto ei ole tällä hetkellä saatavilla.",
    "latest": "Uusimmat videot",
    "more": "Näytä lisää",
    "not_available_in_your_locale": "Tämä video ei ole saatavilla suomeksi. Olemme automaattisesti vaihtaneet toiseen kieleen.",
    "play": "Toista video",
    "quiz": {
      "resume": "Jatka visailua",
      "title": "Visailu"
    },
    "related": "Aiheeseen liittyvät videot",
    "related_videos": "Ehdotetut videot",
    "title": "Videot",
    "watch_again": "Katso uudelleen"
  }
}
